/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantsRoutingModule } from './tenants-routing.module';
import { CreateTenantComponent } from './create-tenant/create-tenant.component';
import { ManageTenantComponent } from './manage-tenant/manage-tenant.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
/**
  * @ngdoc overview
  * @name TenantsModule.module:TenantsModule
  *
  * @description
  * description :
*/
@NgModule({
  declarations: [CreateTenantComponent, ManageTenantComponent],
  imports: [
    CommonModule,
    TenantsRoutingModule,
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatCardModule,
    MatSlideToggleModule,
    TranslateModule,
    FormsModule,
    MatSelectModule
  ]
})
export class TenantsModule { }
